import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import './ExtrasActualizar.scss';

const ExtrasActualizar = ({ type, tipo, modelo, version, anio, color }) => {
  return (
    type && (
      <div className="extras-actualizar">
        <Button to={`/${tipo}/${modelo}/${version}/${anio}/${color}/resumen/`} component={Link} ui="circular" black >
          Actualizar
        </Button>
      </div>
    )
  );
}

export default ExtrasActualizar;